//数组元素是否相同
function ArrayEqual(arr1, arr2) {
    let eq1 = arr1.length === arr2.length;
    if (eq1) {
        for (let item of arr1) {
            if (arr2.includes(item))
                continue;
            return false;
        }
    }
    return eq1;
}
export default ArrayEqual;
